import createClient, { type Client, type Middleware } from 'openapi-fetch';

import type { paths } from './types.gen';

export type ApiClient = Client<paths>;
export type TokenGetter = () => string | null | undefined;

const SAME_ORIGIN_BASE_URL = '';

export function createApiClient(getToken: TokenGetter, baseUrl: string = SAME_ORIGIN_BASE_URL): ApiClient {
  const client = createClient<paths>({ baseUrl });

  const authMiddleware: Middleware = {
    onRequest: ({ request }) => {
      const token = getToken();
      if (token) {
        request.headers.set('Authorization', `Bearer ${token}`);
      }
      return request;
    },
  };
  client.use(authMiddleware);

  return client;
}
